// extracted by mini-css-extract-plugin
module.exports = {"sidePanel":"Toc-SidePanel-module--side-panel--3VTld"};